import { AgeOptionIdType } from '../options/Age/types';
import { getAgeIdByTitle } from '../options/Age/utils/getAgeIdByTitle';

const oldAges: AgeOptionIdType[] = ['35-49', '50_plus'];

export const getAiAgeGeneration = (
  age: string | null | undefined,
): 'old' | 'young' => {
  const ageId = getAgeIdByTitle(age, true);

  if (ageId && oldAges.includes(ageId)) {
    return 'old';
  }

  return 'young';
};

export const getAiAgeGenerationByAgeId = (
  ageId: AgeOptionIdType | null,
): 'old' | 'young' => {
  if (!ageId) {
    return 'young';
  }

  if (oldAges.includes(ageId)) {
    return 'old';
  }

  return 'young';
};
